import { render, staticRenderFns } from "./SurveyReportAttach.vue?vue&type=template&id=6b5a1e1b&"
import script from "./SurveyReportAttach.vue?vue&type=script&lang=js&"
export * from "./SurveyReportAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports